import { useState, useEffect } from 'react';

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export default () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const fontSize = windowDimensions?.width <= 500 ? { fontSize: '4vw' } : { fontSize: '20px' };

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { ...windowDimensions, fontSize };
};
